import React from 'react';
import classNames from 'classnames';
import styles from './progressmeter.module.scss';

// `steps` opts into a discrete segmented stepper (e.g. a 3-step wizard modal)
// instead of the circular percentage donut used elsewhere (payment plans).
export const ProgressMeter = React.memo(({ id, progress, theme, steps, currentStep }) => {

  if (steps) {
    return (
      <div id={id} className={classNames(styles.stepperWrapper, styles[theme])}>
        {Array.from({ length: steps }, (_, index) => (
          <div
            key={index}
            className={classNames(styles.stepperSegment, { [styles.stepperSegmentFilled]: index < currentStep })}
          />
        ))}
      </div>
    );
  }
  return (
    <div className={styles.progressWrapper}>
      <div className={classNames(styles.progressContainer, styles[theme])}>
        <div className={`progress-circle progress-${progress}`}>
          <span />
        </div>
      </div>
    </div>
  );
});
